export default "__VITE_ASSET__DT9el9BW__"